export default "helm-chart-artifact2320ab55b431ba0a.svg"